// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.access_token) localStorage.setItem("skintrack_token", data.access_token);
        setUserFromGoogle(data);
        // Strip hash and land on dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
        toast.success(`Welcome${data.name ? `, ${data.name.split(" ")[0]}` : ""}`);
      } catch (err) {
        const msg = err.response?.data?.detail || err.message || "Google sign-in failed";
        toast.error(typeof msg === "string" ? msg : "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block h-10 w-10 rounded-full border-2 border-sage-300 border-t-sage-500 animate-spin" />
        <p className="mt-4 text-stone-500 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
